export enum TableActionNameEnum {
  CHECKBOX,
  EDIT,
  DOWNLOAD,
  DELETE,
}
